import { render, staticRenderFns } from "./SubConfirm.vue?vue&type=template&id=a2cb27ce&scoped=true&"
import script from "./SubConfirm.vue?vue&type=script&lang=js&"
export * from "./SubConfirm.vue?vue&type=script&lang=js&"
import style0 from "./SubConfirm.vue?vue&type=style&index=0&id=a2cb27ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cb27ce",
  null
  
)

export default component.exports